(() => {
  'use strict';

  const desktopHover = window.matchMedia('(hover: hover) and (pointer: fine)');

  const hydrate = (root = document) => {
    if (!desktopHover.matches) return;

    const templates = root.matches?.('template.gemmarii-secondary-image-template')
      ? [root]
      : Array.from(root.querySelectorAll?.('template.gemmarii-secondary-image-template') || []);

    templates.forEach((template) => {
      const host = template.closest('.card-secondary-image');
      if (!host || host.dataset.gemmariiSecondaryHydrated === 'true') return;

      const content = template.content.cloneNode(true);
      const image = content.querySelector('img');
      if (!image) return;

      const markReady = () => {
        if (image.naturalWidth > 0) host.dataset.gemmariiSecondaryReady = 'true';
      };
      image.addEventListener('load', markReady, { once: true });
      image.addEventListener('error', () => {
        delete host.dataset.gemmariiSecondaryReady;
      }, { once: true });
      host.dataset.gemmariiSecondaryHydrated = 'true';
      host.append(content);
      template.remove();
      if (image.complete) markReady();
    });
  };

  hydrate();

  const catalog = document.querySelector('#AjaxinateContainer');
  if (!catalog) return;

  const observer = new MutationObserver((mutations) => {
    if (!desktopHover.matches) return;

    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) hydrate(node);
      });
    });
  });

  observer.observe(catalog, { childList: true, subtree: true });
})();
